import { notificationKindByCode } from '../Contracts/NotificationKinds'
import { NotificationStore } from '../Stores/NotificationStore'

import type { NotificationToast } from '../Contracts/NotificationKinds'

const text = (value: unknown): string | null => (typeof value === 'string' && value !== '' ? value : null)

/**
 * Подія сповіщень із каналу користувача в Centrifugo — публічне API
 * контейнера для `CentrifugoConnector`.
 *
 * Досі нове сповіщення давало лише тост: дзвіночок мовчав, а відкрита
 * шухляда показувала його тільки після повторного відкриття.
 *
 * @returns чи це була подія сповіщень
 */
export const handleNotificationRealtime = (data: Record<string, unknown>): boolean => {
    const uuid = text(data['uuid'])
    if (!uuid) return false

    if (data['event'] === 'UserNotification.Created') {
        NotificationStore.receive({
            uuid,
            type: text(data['type']) ?? 'system',
            code: text(data['code']),
            title: text(data['title']) ?? '',
            message: text(data['message']) ?? '',
            entityCode: text(data['entityCode']),
            entityUuid: text(data['entityUuid']),
            authorName: text(data['authorName']),
            isReaded: data['isReaded'] === true,
            readedAt: text(data['readedAt']),
            // У публікації часу немає — сповіщення щойно створене
            createdAt: new Date().toISOString(),
        })

        return true
    }

    if (data['event'] === 'UserNotification.Deleted') {
        NotificationStore.discard(uuid, data['isReaded'] === true)

        return true
    }

    return false
}

export interface NotificationToastView {
    type: NotificationToast
    title: string
    description: string
}

/**
 * Тост на нове сповіщення (`SPEC-014` §6.3): підпис і тип — з каталогу за
 * кодом (`warning` для прострочення й помилки листа, `info` для решти),
 * опис — текст сповіщення. Невідомий код — заголовок із публікації й `info`.
 *
 * @returns `null`, якщо публікація — не нове сповіщення (видалення, інше)
 */
export const notificationToast = (data: Record<string, unknown>): NotificationToastView | null => {
    if (data['event'] !== 'UserNotification.Created') return null

    const kind = notificationKindByCode(text(data['code']))

    return {
        type: kind?.toast ?? 'info',
        title: kind?.label ?? text(data['title']) ?? 'Нове сповіщення',
        description: text(data['message']) ?? '',
    }
}
